import React from "react";
import PropTypes from "prop-types";
import Header from "./Header";
import Body from "./Body";
import Footer from "./Footer";
import { pymSendHeight } from "../utils/handlePym";

const SUBTITLE_TEXT =
  "There are huge differences in workloads between magisterial district judges in Pennsylvania. In the chart below, each dot represents a judge. Based on a court administration formula, judges with lower scores had lighter workloads in 2019. Click or tap on a judge to see how their workload compared to the average for their county.";

const FOOTNOTE_TEXT =
  "Recommended workload levels are +/-15% the average workload for all judges in a county. Ranges are based on recommendations made by the courts in 2011. Note that Philadelphia is not included because it does not have magisterial district court judges and uses different processes for managing cases. Judges from Luzerne and certain judges from Allegheny County have been excluded due to concerns about data accuracy.";

class Main extends React.Component {
  componentDidMount() {
    // This is intended to fix bug where app is clipped at bottom
    // on initial load.
    pymSendHeight({ timeout: 500 });
    pymSendHeight({ timeout: 1000 });
  }

  componentDidUpdate() {
    // Because our app changes height based on displayed content, we
    // update the iframe height after DOM elements have been updated.
    pymSendHeight();
  }

  render() {
    const { data } = this.props;
    return (
      <div className="container__outer">
        <div className="container__inner">
          <Header headline="Unequal workloads" subtitle={SUBTITLE_TEXT} />
          <Body data={data} />
          <Footer
            footnote={FOOTNOTE_TEXT}
            byline="Daniel Simmons Ritchie"
            source="Spotlight PA analysis of caseload data provided by the Administrative Office of the Pennsylvania Courts."
            outlet="Spotlight PA"
            outletUrl="https://www.spotlightpa.org/"
          />
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  data: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default Main;
